export default "__VITE_ASSET__B_lr1hNw__"